import axios from 'axios';

const insertPageView = async (pageId: number) => {
    try {
        const response = await axios.post<boolean>(`/api/pageview?pageId=${pageId}`);
    } catch (error) {
        console.error(error);
    }
};

export default insertPageView;
